import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';

export const INITIAL_STATE = {
    columns: constants.columns,
    csas: [],
    loading: false,
    initialised: false,
    currentServerFilters: [],
    filterDefinitions: constants.filterDefinitions,
    defaultFilters: constants.defaultFilters,
    rows: constants.fakeRows
};

const setInitialised = fp.set('initialised');
const setLoading = fp.set('loading');
const setCsas = fp.set('csas');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return setInitialised(action.initialised, state);
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_CSAS: {
            return setCsas(action.csas, state);
        }
        case actions.SET_ROWS: {
            return {
                ...state,
                rows: action.rows,
                currentServerFilters: action.serverFilters
            };
        }
        default:
            return state;
    }
}
